import store from "../util/store.jsx";
import { CheckpointListView } from "../views/checkpointListView.jsx";
import locationInfo from "../data/locationInfo.json";

function CheckpointList() {
  const state = store.getState();

  const userCheckpointsData = state.userData.userProgress.stockholm || {};

  const visitedIds = Object.keys(userCheckpointsData || {});
  const allLocations = Object.entries(locationInfo); // better for lookup by ID

  // Sort: visited first
  const sortedLocations = [...allLocations].sort(([aId], [bId]) => {
    const aVisited = visitedIds.includes(aId);
    const bVisited = visitedIds.includes(bId);

    if (aVisited === bVisited) return 0;
    return aVisited ? -1 : 1;
  });

  function GotoCheckPointACB(id) {
     if (visitedIds.includes(id)) {
    window.location.hash = `#/checkpoint/${id}`; // already visited
  } else {
    window.location.hash = `#/arrivalCheck/${id}`; // first time
  }
  }

  return (
    <CheckpointListView
      onGotoCheckPoint={GotoCheckPointACB}
      userCheckpointsData={userCheckpointsData}
      sortedLocations={sortedLocations}
      visitedIds={visitedIds}
      onDiscover={GotoCheckPointACB}
    />
  );
}

export { CheckpointList };
